export const DARK_COLOR_SCHEME = 'color-scheme2|color-scheme4|color-scheme7';
export const SMALL_FONT_SIZE = 'small';
export const TARGET_CARD = 'Data From Target';
export const MODEL_CARD = 'Data From AEM';
export const VARIATION_ONE = 'variationone';
export const VARIATION_TWO = 'variationtwo';
export const BRIGHTCOVE_SRC = 'https://players.brightcove.net';
export const FILTER_TYPES = {
  BEDROOMS: 'mi-luxury-spa:bedrooms',
  ANY_BEDROOMS: 'mi-luxury-spa:bedrooms/any',
  COUNTRY: 'mi-luxury-spa:country',
  CONNECTING_ROOMS: 'mi-luxury-spa:connecting-rooms',
  BRANDS: 'mi-luxury-spa:brands',
  ACTIVITIES: 'mi-luxury-spa:activities',
};

export const MOCK_DATA_TYPES = {
  PROPERTIES_MOCK_DATA: 'propertiesMockData',
  FACETS_MOCK_DATA: 'facetsMockData',
};

export const slash = '/';
export const miniCardHeight = 112;
export const miniCardWidth = 344;
export const smallMobileMiniCardWidth = 324;

// A mapping of URL parameter keys to the desired output structure
export const parameterMap = {
  marriottBrands: {
    type: FILTER_TYPES.BRANDS,
    dimensionPrefix: '',
  },
  locations: {
    type: FILTER_TYPES.COUNTRY,
    dimensionPrefix: FILTER_TYPES.COUNTRY + slash,
  },
  activities: {
    type: FILTER_TYPES.ACTIVITIES,
    dimensionPrefix: FILTER_TYPES.ACTIVITIES + slash,
  },
  bedrooms: {
    type: FILTER_TYPES.BEDROOMS,
    dimensionPrefix: FILTER_TYPES.BEDROOMS + slash,
  },
  connectingRooms: {
    type: FILTER_TYPES.CONNECTING_ROOMS,
    dimensionPrefix: FILTER_TYPES.CONNECTING_ROOMS + slash,
    valueMap: {
      true: 'show-rooms-that-connect',
    },
  },
};

// A mapping of URL parameter keys to the desired output structure
export const MAPS_FILTERS_URL_PARAMS_MAPPING = {
  marriottBrands: {
    type: 'BRANDS',
    dimensionPrefix: '',
  },
  amenities: {
    type: 'AMENITIES',
    dimensionPrefix: '',
  },
  region: {
    type: 'LEISURE_REGIONS',
    dimensionPrefix: '',
  },
  cities: {
    type: 'CITIES',
    dimensionPrefix: '',
  },
  states: {
    type: 'STATES',
    dimensionPrefix: '',
  },
  countries: {
    type: 'COUNTRIES',
    dimensionPrefix: '',
  },
  activities: {
    type: 'ACTIVITIES',
    dimensionPrefix: '',
  },
  hotelType: {
    type: 'PROPERTY_TYPES',
    dimensionPrefix: '',
  },
};

export const FILTER_PARAMS = {
  BRANDS_PARAM: 'marriottBrands',
  BEDROOMS_PARAM: 'bedrooms',
  LOCATIONS_PARAM: 'locations',
  ACTIVITIES_PARAM: 'activities',
  CONNECTING_ROOMS_PARAM: 'connectingRooms',
  CONNECTING_ROOMS_PARAM_VAL: 'show-rooms-that-connect',
};

export const MOBILE_COL_LENGTH = 12;
export const COL_LENGTH = 6;

export const MOBILE_NAVBAR_HEIGHT = 52;
export const NAVBAR_HEIGHT = 88;
export const IMAGE_URL_DOMAIN = 'https://cache.marriott.com';

export const LOCATIONS = ['CITIES', 'STATES', 'COUNTRIES'];

export const LOCATION = [
  {
    filterName: 'COUNTRIES',
  },

  {
    filterName: 'STATES',
  },

  {
    filterName: 'CITIES',
  },
];

export const DEFAULT_FILTERS_ORDER = [
  {
    filterName: 'LEISURE_REGIONS',
  },
  {
    filterName: 'LOCATION',
  },
  {
    filterName: 'ACTIVITIES',
  },
  {
    filterName: 'BRANDS',
  },
  {
    filterName: 'AMENITIES',
  },
  {
    filterName: 'PROPERTY_TYPES',
  },
];

export const FILTERS_MAPPING = {
  Brands: 'BRANDS',
  Amenities: 'AMENITIES',
  Activities: 'ACTIVITIES',
  Property: 'PROPERTY_TYPES',
  Regions: 'LEISURE_REGIONS',
  Location: 'LOCATION',
  City: 'CITIES',
  State: 'STATES',
  Country: 'COUNTRIES',
};

export const ClusterSvgIcon = `
<!-- Outer gray circle -->
<svg xmlns="http://www.w3.org/2000/svg" width="74" height="74" viewBox="0 0 74 74" fill="none">
  <circle cx="37" cy="37" r="37" fill="black" fill-opacity="0.1"/>

<!-- Inner black circle -->
  <circle cx="37" cy="37" r="25" fill="#1C1C1C"/>
</svg> `;

export const MapPinSvgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="19.5 15.5 20 20" fill="none">
  <g filter="url(#filter0_d_5380_127907)">
    <circle cx="30" cy="26" r="10" fill="#1C1C1C"/>
    <circle cx="30" cy="26" r="9.5" stroke="white"/>
  </g>
  <defs>
    <filter id="filter0_d_5380_127907" x="0" y="0" width="60" height="60" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="4"/>
      <feGaussianBlur stdDeviation="10"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5380_127907"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5380_127907" result="shape"/>
    </filter>
  </defs>
</svg>`;

export const MapPinActiveSvgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="19.5 15.5 20 20" fill="none">
  <g filter="url(#filter0_d_5380_127909)">
    <circle cx="30" cy="26" r="10" fill="white"/>
    <circle cx="30" cy="26" r="9.5" stroke="#1C1C1C"/>
  </g>
  <defs>
    <filter id="filter0_d_5380_127909" x="0" y="0" width="60" height="60" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="4"/>
      <feGaussianBlur stdDeviation="10"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5380_127909"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5380_127909" result="shape"/>
    </filter>
  </defs>
</svg>`;

export const TAB_ICONS = {
  map: 'icon-map',
  list: 'icon-list-view',
};

export const MILESTOMETERS = 1609.34;
export const SPACING = 8;
export const DEFAULT_PLUS_WIDTH = 17;
export const PROPERTIES_LIMIT = 250;

export const REGION_FILTER = new Set(['LEISURE_REGIONS']);
export const LOCATION_KEYS = ['CITIES', 'STATES', 'COUNTRIES'];

export const LOC_QUERY_MAPPING: Record<string, string> = {
  LEISURE_REGIONS: 'region',
  CITIES: 'cities',
  STATES: 'states',
  COUNTRIES: 'countries',
};

export const QUERY_PARAM_MAPPING: Record<string, string> = {
  BRANDS: 'marriottBrands',
  AMENITIES: 'amenities',
  PROPERTY_TYPES: 'hotelType',
  ACTIVITIES: 'activities',
  ...LOC_QUERY_MAPPING,
};

export const EVENT_NAME = {
  PAGEVIEW: 'PAGEVIEW',
};

export enum STATUS_IN_BOOLEAN {
  TRUE = 'TRUE',
  FALSE = 'FALSE',
}
